import { useState, useLayoutEffect } from "react";
import {
    Autocomplete,
    Box,
    Button,
    createFilterOptions,
    TextField,
    Typography,
} from "@mui/material";
import axios from "axios";
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { GridColDef } from '@mui/x-data-grid';
import Divider from '@mui/material/Divider';
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { IGreenhouse } from "../../interfaces/IGreenhouse";
import { IBay } from "../../interfaces/IBay";
import { IZone } from "../../interfaces/IZone";
import { IBench } from "../../interfaces/IBench";
import { IItemHeader } from "../../interfaces/IItemHeader";
import { IItemDetail } from "../../interfaces/IItemDetail";
import { styled } from '@mui/material/styles';
import { ITray } from "../../interfaces/ITray";
import { setPageTitle } from "../../slices/applicationSlice";
import { IApplication } from "../../interfaces/IApplication";
import { useAppSelector, useAppDispatch } from "../../hooks";
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import { IPurchaseOrder } from "../../interfaces/PurchaseOrder/IPurchaseOrder";
import { DatePicker } from "@mui/x-date-pickers";
import { IVendor, IVendors } from "../../interfaces/PurchaseOrder/IVendor";
import { IUsers } from "../../interfaces/IUser";
import { setPurchaseOrder } from "../../slices/purchaseOrderSlice";


type Props = {
    setTabValue: React.Dispatch<React.SetStateAction<number>>,
    setDetailType: (props: string) => void,
    hideButtons: boolean
}

export default function PoHeader(props: Props) {
    const { setTabValue, setDetailType, hideButtons } = props;
    const [openSuccess, setSuccess] = React.useState(false);

    const handleSuccess = () => {
        setSuccess(true);
    };

    const handleSuccessClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setSuccess(false);
    };

    const dispatch = useAppDispatch();
    const currentPurchaseOrder = useAppSelector((state) => state.purchaseOrder.purchaseOrder);

    useLayoutEffect(() => {
        let appState: IApplication = {
            pageTitle: "Purchase Order - Header",
            backgroundPath: "/assets/images/inventorybg.jpg"
        }
        dispatch(setPageTitle(appState));
    }, []);

    const [itemHeaders, setItemHeaders] = React.useState<IItemHeader[]>([]);
    const [types, setTypes] = React.useState<string[]>([]);
    const [users, setUsers] = React.useState<IUsers>([]);
    const [vendors, setVendors] = React.useState<IVendors>([]);
    const [selectedItemDetail, setSelectedItemDetail] = React.useState<IItemDetail>();
    const [greenHouses, setGreenHouses] = React.useState<IGreenhouse[]>([]);
    const [currentGreenhouse, setCurrentGreenhouse] = React.useState<IGreenhouse>();
    const [bays, setBays] = React.useState<IBay[]>([]);
    const [currentBay, setCurrentBay] = React.useState<IBay>();
    const [zones, setZones] = React.useState<IZone[]>([]);
    const [currentZone, setCurrentZone] = React.useState<IZone>();
    const [benches, setBenches] = React.useState<IBench[]>([]);
    const [currentBench, setCurrentBench] = React.useState<IBench>();

    const [rows, setRows] = useState<IGreenhouse[] | IBay[] | IZone[] | IBench[] | ITray[]>([]);

    useLayoutEffect(() => {
        axios
            .get(`${process.env.REACT_APP_ENDPOINT}/api/ItemHeaders`)
            .then(res => {
                console.log("Response", res);
                setItemHeaders(res.data);
            });

        axios
            .get(`${process.env.REACT_APP_ENDPOINT}/api/Vendors`)
            .then(res => {
                console.log("Vendors", res.data);
                setVendors(res.data);
            })

        axios
            .get<IUsers>(`${process.env.REACT_APP_ENDPOINT}/api/Users`)
            .then(res => {
                console.log("Response", res);
                setUsers(res.data);
            });
            
        if (currentPurchaseOrder != null) {
            reset(currentPurchaseOrder);
        }
    }, []);

    useLayoutEffect(() => {
        if (currentGreenhouse) {
            setBays(currentGreenhouse.bays)
            setRows(currentGreenhouse.bays);
        } else {
            setBays([]);
            setRows([])
            setCurrentBay(undefined);
        }
    }, [currentGreenhouse])

    useLayoutEffect(() => {
        if (currentBay) {
            setZones(currentBay.zones)
            setRows(currentBay.zones);
        } else {
            setZones([]);
            if (currentGreenhouse && currentGreenhouse.bays) {
                setRows(currentGreenhouse.bays);
            }
            setCurrentZone(undefined);
        }
    }, [currentBay])

    useLayoutEffect(() => {
        if (currentZone) {
            setBenches(currentZone.benches)
            setRows(currentZone.benches);
        } else {
            setBenches([]);
            if (currentBay && currentBay.zones) {
                setRows(currentBay.zones);
            }
        }
    }, [currentZone])

    useLayoutEffect(() => {
        if (currentBench) {
            // setRows(currentBench.trays)
        } else {
            setBenches([]);
        }
    }, [currentBench])

    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#191919' : '#fff',
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        border: 0,
        borderRadius: 0,
        boxShadow: "none",
        backgroundImage: "none",

    }));


    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const { register, handleSubmit, control, formState: { errors }, getValues, setValue, reset } = useForm<IPurchaseOrder>();
    const filter = createFilterOptions<IVendor>();
    const onSubmit: SubmitHandler<IPurchaseOrder> = data => {
        console.log("IN ON SUBMIT", data);
        data.type = "item";
        dispatch(setPurchaseOrder(data));
    };
    const trayColumns: GridColDef[] = [
        // { field: 'id', headerName: 'ID', width: 70 },
        { field: 'name', headerName: 'Name', width: 250 },
        { field: 'description', headerName: 'Description', width: 350 },
        { field: 'species', headerName: 'Species', width: 300 },
        { field: 'variety', headerName: 'Variety', width: 250 },
        { field: 'color', headerName: 'Color', width: 200 },
    ];

    const [trayRows, setTrayRows] = useState<ITray[]>([]);
    return (
        <Box id="mainForm" component="form">
            <Grid container spacing={0}>
                <Grid item xs={12} bgcolor='rgba(255, 255, 255, 1)'>
                    <Grid container spacing={0}>
                        <Grid item xs={12}>
                            <Grid container spacing={1} padding={3}>
                                <Grid item xs={4}>
                                    <Item sx={{ bgcolor: 'transparent' }}>
                                        <Controller
                                            {...register('orderDate', { valueAsDate: true })}
                                            control={control}
                                            render={
                                                ({ field: { onChange, ...restField } }) =>
                                                    <DatePicker
                                                        label="Order Date"
                                                        onChange={(event) => { onChange(event); }}
                                                        renderInput={(params) =>
                                                            <TextField
                                                                fullWidth
                                                                variant="outlined"
                                                                {...params}
                                                            />}
                                                        {...restField}
                                                    />
                                            }
                                        />
                                    </Item>
                                </Grid>
                                <Grid item xs={4}>
                                    <Item sx={{ bgcolor: 'transparent' }}>
                                        <TextField required variant="outlined" fullWidth id="ordernumber" label="Order Number" {...register('orderNumber')} />
                                    </Item>
                                </Grid>
                                <Grid item xs={4}>
                                    <Item>
                                        <Controller
                                            control={control}
                                            name='vendor'
                                            render={({ field: { ref, onChange, value, ...field } }) => (
                                                <Autocomplete
                                                    value={value}
                                                    onChange={(event, newValue) => {
                                                        if (typeof newValue === 'string') {
                                                            setValue('vendor', {
                                                                name: newValue,
                                                            });
                                                        } else if (newValue && newValue.name) {
                                                            // Create a new value from the user input
                                                            setValue('vendor', {
                                                                name: newValue.name,
                                                            });
                                                        } else {
                                                            setValue('vendor', newValue);
                                                        }
                                                    }}
                                                    filterOptions={(options, params) => {
                                                        const filtered = filter(options, params);

                                                        const { inputValue } = params;
                                                        // Suggest the creation of a new value
                                                        const isExisting = options.some((option) => inputValue === `${option.name}`);
                                                        if (inputValue !== '' && !isExisting) {
                                                            filtered.push({
                                                                name: `${inputValue}`,
                                                            });
                                                        }

                                                        return filtered;
                                                    }}
                                                    selectOnFocus
                                                    clearOnBlur
                                                    handleHomeEndKeys
                                                    autoSelect
                                                    id="vendorSelect"
                                                    options={vendors}
                                                    getOptionLabel={(option) => {
                                                        // Value selected with enter, right from the input
                                                        if (typeof option === 'string') {
                                                            return option;
                                                        }
                                                        // Add "xxx" option created dynamically
                                                        if (option.name) {
                                                            return option.name;
                                                        }
                                                        // Regular option
                                                        return option.name;
                                                    }}
                                                    renderOption={(props, option) => <li {...props}>{`${option.name}`}</li>}
                                                    freeSolo
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Vendor" />
                                                    )}
                                                />
                                            )}
                                        />
                                    </Item>
                                </Grid>
                                <Grid item xs={4}>
                                    <Item>
                                        <Controller
                                            control={control}
                                            name='user'
                                            render={({ field: { ref, onChange, value, ...field } }) => (
                                                <Autocomplete
                                                    value={value}
                                                    options={users}
                                                    autoSelect
                                                    getOptionLabel={(option) => `${option.firstName} ${option.lastName}`}
                                                    onChange={(_, data) => {
                                                        return onChange(data);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField {...params} {...field} fullWidth inputRef={ref} variant="outlined" label="Created By" sx={{ fontSize: '24px', fontWeight: '900' }}></TextField>
                                                    )}
                                                />
                                            )}
                                        />
                                    </Item>
                                </Grid>
                                <Grid item xs={4}>
                                    <Item sx={{ bgcolor: 'transparent' }}>
                                        <TextField required variant="outlined" fullWidth id="salesordernumber" label="Sales Order Number" {...register('salesOrderNumber')} />
                                    </Item>
                                </Grid>
                                <Grid item xs={4}>
                                    <Item sx={{ bgcolor: 'transparent' }}><TextField required variant="outlined" fullWidth id="department" label="Department" {...register('department')} /></Item>
                                </Grid>
                                <Grid item xs={4}>
                                    <Item sx={{ bgcolor: 'transparent' }}><TextField required variant="outlined" fullWidth id="discounts" label="Discounts" {...register('discounts')} /></Item>
                                </Grid>
                                <Grid item xs={8} >
                                    <Item sx={{ bgcolor: 'transparent' }}><TextField required variant="outlined" fullWidth id="description" label="Description" {...register('description')} /></Item>
                                </Grid>
                                <Grid item xs={12} sx={{ mb: 2, mt: 1 }}><Divider /></Grid>
                                {!hideButtons &&
                                    <Grid item xs={6}>
                                        <Button
                                            fullWidth
                                            onClick={() => { handleSubmit(onSubmit)(); setDetailType('item'); setTabValue(1); }}
                                            variant="contained"
                                            color="primary"
                                            sx={{ p: 2 }}
                                            size="large"
                                            endIcon={<CheckCircleIcon />}
                                        >
                                            <Typography variant="h5">
                                                By Item
                                            </Typography>
                                        </Button>
                                    </Grid>}
                                {!hideButtons &&
                                    <Grid item xs={6} >
                                        <Button
                                            fullWidth
                                            onClick={() => { handleSubmit(onSubmit)(); setDetailType('order'); setTabValue(1); }}
                                            variant="contained"
                                            color="secondary"
                                            sx={{ p: 2 }}
                                            size="large"
                                            endIcon={<CheckCircleIcon />}
                                        >
                                            <Typography variant="h5">
                                                By Order
                                            </Typography>
                                        </Button>
                                    </Grid>}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
}